import Component from '../Component';

class LinkExternal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return `
            <a class="link" href="${this.props.href}" target="_blank">${this.props.text}</a>
        `;
    }
}

export default LinkExternal;